"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiCompleteNewPasswordRequest = instanceOfApiCompleteNewPasswordRequest;
exports.ApiCompleteNewPasswordRequestFromJSON = ApiCompleteNewPasswordRequestFromJSON;
exports.ApiCompleteNewPasswordRequestFromJSONTyped = ApiCompleteNewPasswordRequestFromJSONTyped;
exports.ApiCompleteNewPasswordRequestToJSON = ApiCompleteNewPasswordRequestToJSON;
exports.ApiCompleteNewPasswordRequestToJSONTyped = ApiCompleteNewPasswordRequestToJSONTyped;
/**
 * Check if a given object implements the ApiCompleteNewPasswordRequest interface.
 */
function instanceOfApiCompleteNewPasswordRequest(value) {
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
function ApiCompleteNewPasswordRequestFromJSON(json) {
    return ApiCompleteNewPasswordRequestFromJSONTyped(json, false);
}
function ApiCompleteNewPasswordRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'password': json['password'],
    };
}
function ApiCompleteNewPasswordRequestToJSON(json) {
    return ApiCompleteNewPasswordRequestToJSONTyped(json, false);
}
function ApiCompleteNewPasswordRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'password': value['password'],
    };
}
